import axios from 'axios';

export type CreateCustomerParams = {
	email: string;
	firstName: string;
	lastName: string;
	phone?: string;
	zipcode?: string;
	getToken: () => Promise<string>;
	setState?: (data: any) => void;
	setError?: (error: string) => void;
};

export const createCustomer = async (params: CreateCustomerParams): Promise<[any, string | null]> => {
	const { email, firstName, lastName, phone, zipcode, getToken, setState, setError } = params;

	try {
		const token = await getToken();
		const response = await axios.post(
			`${import.meta.env.VITE_API_URL}/customer`,
			{ email, firstName, lastName, phone, zipcode },
			{
				headers: {
					Authorization: `Bearer ${token}`
				}
			}
		);

		if (response.status !== 200) {
			if (setError) setError(response.data);
			return [null, response.data];
		}

		if (setState) setState(response.data);
		return [response.data, null];
	} catch (error) {
		const errorMessage = error instanceof Error ? error.message : 'Error creating customer';
		if (setError) setError(errorMessage);
		return [null, errorMessage];
	}
};
